import React, { ChangeEvent } from 'react';
import './style.scss';
import PickerLegacy from './PickerLegacy';
import PickerUpdated from './PickerUpdated';

export type SourceOption = {
  value: string;
  body: string;
  disabled?: boolean;
};

export type PickerProps = {
  options: SourceOption[];
  value: string;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  className?: string;
  isLegacy?: boolean;
};

const Picker: React.FC<PickerProps> = ({ isLegacy = true, ...props }) => {
  return isLegacy ? <PickerLegacy {...props} /> : <PickerUpdated {...props} />;
};

export default React.memo(Picker);
